import { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Pusher from 'pusher-js';
import { PUSHER_ACTIVITY_TIMEOUT_MILLISECONDS, REFRESH_APP } from 'constants/pusher';

export default function useProvidePusher() {
  // Holds a reference to the pusher channel
  const [pusher, setPusher] = useState(null);
  // Holds a reference to the event channel, needed for disconnect
  const [channels, setChannels] = useState(null);
  /**
   * String value for the channel name, setting it will cause
   * pusher to create a new channel ref
   */
  const [channelNames, setChannelNames] = useState(null);

  useEffect(() => {
    const pusherInstance = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
      cluster: import.meta.env.VITE_PUSHER_CLUSTER,
      activityTimeout: PUSHER_ACTIVITY_TIMEOUT_MILLISECONDS,
    });
    const pusherChannels = channelNames?.map(
      channelName =>
        // eslint-disable-next-line implicit-arrow-linebreak
        pusherInstance.subscribe(channelName),
      // eslint-disable-next-line function-paren-newline
    );

    // Global Channel so we can force refresh the app
    const globalChannelName = `${import.meta.env.VITE_WEB_SOCKET_STAGE}-cuboh-dashboard`;
    const channel = pusherInstance.subscribe(globalChannelName);
    channel.bind_global(event => {
      if (event === REFRESH_APP) {
        setTimeout(
          () => {
            window.location.reload(true);
          },
          Math.floor(Math.random() * 30000),
        );
      }
    });

    setChannels(pusherChannels);
    setPusher(pusherInstance);

    /** Cleanup on unmount/re-render */
    return () => {
      channelNames?.forEach(channelName => pusherInstance.unsubscribe(channelName));
      pusherInstance.unsubscribe(globalChannelName);
    };
  }, [channelNames]);

  return { setChannelNames, pusher, channels, channelNames };
}
